import React, { memo } from 'react'

import CampoVinculos from '../../components/CampoVinculos'
import {
  CheckboxLabel, FieldError, FormGrid, FormLabel, FormRow, FormSection, TextArea, TextInput
} from '../../components/ui'

/* Cadastro da clínica. A casca do modal vem do FormModal.

   Quase tudo aqui é o que o paciente vê antes de escolher onde fazer o exame:
   telefone, WhatsApp, horário e descrição. O endereço continua no modal
   próprio, com busca por CEP — são vários por clínica, não cabe em campo. */

const Campo = ({ label, name, full, values, errors, touched, handleChange, handleBlur, ...rest }) => (
  <FormRow $full={full}>
    <FormLabel>{label}</FormLabel>
    <TextInput
      autoComplete='nope'
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      $error={!!errors[name]}
      {...rest}
    />
    <FieldError>{touched[name] && errors[name]}</FieldError>
  </FormRow>
)

const Marcar = ({ label, name, values, handleChange }) => (
  <FormRow>
    <CheckboxLabel>
      <input type='checkbox' name={name} checked={!!values[name]} onChange={handleChange} />
      {label}
    </CheckboxLabel>
  </FormRow>
)

const Form = ({
  isCreating = false, values, errors, touched, handleChange, handleBlur, setFieldValue,
  especialidades = [], planos = []
}) => {
  const props = { values, errors, touched, handleChange, handleBlur }

  return (
    <FormGrid>
      <FormSection>Identificação</FormSection>

      <Campo label='Nome' name='name' full {...props} />
      <Campo label='E-mail de acesso' name='login' type='email' {...props} />
      {isCreating && <Campo label='Senha' name='password' type='password' {...props} />}

      <FormSection>Contato</FormSection>

      <Campo label='E-mail comercial' name='comercial_email' type='email' {...props} />
      <Campo label='Telefone' name='phone' placeholder='(00) 0000-0000' {...props} />
      <Campo label='WhatsApp' name='whatsapp' placeholder='(00) 00000-0000' {...props} />
      <Campo label='Site' name='website' placeholder='https://' {...props} />

      <FormRow $full>
        <FormLabel>Horário de atendimento</FormLabel>
        <TextArea name='working_time' value={values.working_time || ''}
          onChange={handleChange} onBlur={handleBlur}
          placeholder='Seg a Sex, 7h às 19h · Sáb, 8h às 12h' />
        <FieldError />
      </FormRow>

      <FormSection>Apresentação</FormSection>

      <Campo label='Descrição curta' name='small_description' full
        placeholder='Uma linha, aparece na lista de clínicas' {...props} />

      <FormRow $full>
        <FormLabel>Descrição</FormLabel>
        <TextArea name='description' value={values.description || ''}
          onChange={handleChange} onBlur={handleBlur} />
        <FieldError />
      </FormRow>

      <FormSection>Serviços e visibilidade</FormSection>

      <Marcar label='Faz exames' name='has_exam' values={values} handleChange={handleChange} />
      <Marcar label='Faz agendamento' name='has_schedule' values={values} handleChange={handleChange} />
      <Marcar label='Agenda exames' name='has_schedule_exam' values={values} handleChange={handleChange} />
      <Marcar label='Exige login do paciente' name='need_login' values={values} handleChange={handleChange} />
      <Marcar label='Visível na busca' name='visible' values={values} handleChange={handleChange} />

      <FormSection>Especialidades e planos</FormSection>

      <CampoVinculos
        label='Especialidades' name='specialties' opcoes={especialidades}
        values={values} setFieldValue={setFieldValue}
        vazio='Nenhuma especialidade cadastrada. Cadastre em Especialidades.'
      />

      <CampoVinculos
        label='Planos atendidos' name='health_insurances' opcoes={planos}
        values={values} setFieldValue={setFieldValue}
        vazio='Nenhum plano cadastrado. Cadastre em Planos.'
      />
    </FormGrid>
  )
}

export default memo(Form)
